import { getUserLanguageCode } from 'js/lib/language';
import user from 'js/lib/user';

import {
  BROWSE_IN_SEARCH_BEGINNER_FACETFILTER_VALUES,
  BROWSE_IN_SEARCH_BEGINNER_INDEX_ID,
  BROWSE_IN_SEARCH_MOST_POPULAR_FACETFILTER_VALUES,
  BROWSE_IN_SEARCH_MOST_POPULAR_INDEX_ID,
  BROWSE_IN_SEARCH_PARTNERS_INDEX_ID,
  NUMBER_OF_RESULTS_PER_COLLECTION,
} from 'bundles/search-common/constants';
import type { SearchConfig } from 'bundles/search-common/providers/searchTypes';

import _t from 'i18n!nls/search-common';

const getBrowseInSearchCollectionsConfig = ({ filterAttributes }: { filterAttributes: string[] }): SearchConfig[] => {
  const userLanguage = user.isAuthenticatedUser() ? getUserLanguageCode() : _t.getLocale();
  const localeIsEnglish = userLanguage.startsWith('en');
  const mostPopularCollectionFacetFilterValues = [...BROWSE_IN_SEARCH_MOST_POPULAR_FACETFILTER_VALUES];
  const beginnerCollectionFacetFilterValues = [...BROWSE_IN_SEARCH_BEGINNER_FACETFILTER_VALUES];
  if (localeIsEnglish) {
    mostPopularCollectionFacetFilterValues.push(['language:English']);
    beginnerCollectionFacetFilterValues.push(['language:English']);
  }
  return [
    {
      id: BROWSE_IN_SEARCH_MOST_POPULAR_INDEX_ID,
      entityType: 'PRODUCTS',
      limit: NUMBER_OF_RESULTS_PER_COLLECTION,
      facetFilters: mostPopularCollectionFacetFilterValues,
      syncQueryWithUrl: true,
      sortBy: 'BEST_MATCH',
    },
    {
      id: BROWSE_IN_SEARCH_BEGINNER_INDEX_ID,
      entityType: 'PRODUCTS',
      limit: 6, // fetching double amount and removing if duplicates from most popular
      facetFilters: beginnerCollectionFacetFilterValues,
      syncQueryWithUrl: true,
      sortBy: 'BEST_MATCH',
    },
    {
      id: BROWSE_IN_SEARCH_PARTNERS_INDEX_ID,
      entityType: 'PRODUCTS',
      limit: 24,
      facets: filterAttributes,
      syncQueryWithUrl: true,
      sortBy: 'BEST_MATCH',
    },
  ];
};
export default getBrowseInSearchCollectionsConfig;
